import React from 'react';
import { 
  AuthProvider, 
  DialogProvider,
  DrawerProvider, 
  DownloadProvider, 
  ThemeContextChange,
  SnackbarProvider,
} from './shared/context';
import {Login, Sidebar} from './shared/components'
import './style/ResetCss.css';
import RoutesExport from './Routes';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <SnackbarProvider>
      <AuthProvider>
        <ThemeContextChange>
          <Login>
            <DrawerProvider>
              <BrowserRouter>
                <DownloadProvider>
                  <Sidebar>
                    <DialogProvider>
                      <RoutesExport/>
                    </DialogProvider>
                  </Sidebar>
                </DownloadProvider>
              </BrowserRouter>
            </DrawerProvider>
          </Login>
        </ThemeContextChange>
      </AuthProvider>
    </SnackbarProvider>
  );
}

export default App;
